import {Outlet} from "react-router-dom";
import Illustration from "../../Assets/images/illustrations/medicine.svg";

export const AuthenticationLayout = (props) => {
    return (
        <div className={'h-full min-h-screen bg-lightGray'}>
            <div className={'grid w-full grid-cols-2 gap-4 bg-lightGray'}>
                <div className={'w-full p-3'}>
                    <div
                        className={'relative rounded-lg p-4 flex-col justify-center hidden md:flex h-full w-full'}>
                        <div className={'absolute top-0 left-0 bg-gradient-to-b opacity-20 from-primary to-secondary w-full h-full rounded-lg'}>&nbsp;</div>
                        <img src={Illustration} alt={'Illustration of a doctor'} className={'m-auto max-h-[50%]'}/>
                    </div>
                </div>
                <div className={'flex flex-col justify-center items-center h-full w-full  col-span-2 md:col-span-1 p-4'}>
                    <Outlet></Outlet>
                </div>
            </div>
        </div>
    );
}